
import { Options, Prop, Vue } from 'vue-property-decorator'

import WidgetBlock from './widget/WidgetBlock.vue'

@Options({
  name: 'Banner',
  components: {
    WidgetBlock
  }
})
export default class Banner extends Vue {
  @Prop({
    type: String,
    default: ''
  })
  readonly zoneId!: string

  @Prop({
    type: String,
    default: ''
  })
  readonly zoneKey!: string

  @Prop({
    type: Boolean,
    default: true
  })
  readonly showBackground!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  readonly showPlaceholder!: boolean

  @Prop({
    type: String,
    default: 'bottom'
  })
  readonly labelPosition!: 'bottom' | 'left' | ''

  @Prop({
    type: Number
  })
  readonly minHeight?: number

  isFullfilled = false
  observer: MutationObserver | null = null
  banner: HTMLDivElement | null = null

  init () {
    this.banner = this.$refs.banner as HTMLDivElement | null
    if (this.banner) {
      this.observer?.observe(this.banner, { attributes: true, childList: true, subtree: true, attributeFilter: ['style'] })
      this.updateStatus()

      window.googletag = window.googletag || { cmd: [] }
      window.googletag.cmd.push(() => {
        window.googletag.setConfig({
          collapseDiv: 'BEFORE_FETCH'
        })
        window.googletag.pubads().addEventListener('slotRenderEnded', (event: any) => {
          const slotId = event.slot.getSlotElementId()
          const el = document.getElementById(slotId)

          if (el && this.banner && el.closest('.banner__content') === this.banner) {
            const isFullfilled = !event.isEmpty && event.size && event.size[0] > 1 && event.size[1] > 1
            const dimension = isFullfilled ? this.getDimension() : { width: 0, height: 0 }
            const newValue = dimension.height > 1
        
            if (this.isFullfilled !== newValue) {
              this.isFullfilled = newValue
              this.$emit('change', dimension)
            }
          }
        })
      })
    }
  }

  getContents (): Array<HTMLElement> | null {
    if (!this.banner) {
      return null
    }

    const slot = this.banner.querySelector('[data-google-query-id]') as HTMLElement | undefined

    if (slot) {
      const frames = (Array.from(slot.querySelectorAll('iframe')) as Array<HTMLIFrameElement>).map((frame) => {
        return frame.matches('[src]') ? frame : frame.contentDocument?.body
      }).filter((el): el is HTMLIFrameElement => !!el)

      return frames.length ? frames : [slot]
    }
    
    return Array.from(this.banner.querySelectorAll('iframe, video, img, a')) as Array<HTMLElement>
  }

  getDimension () {
    const contents = this.getContents()
    const target = contents ? contents.find(el => el.offsetHeight > 1) : this.banner
    return {
      width: target?.offsetWidth ?? 0,
      height: target?.offsetHeight ?? 0
    }
  }

  updateStatus () {
    if (this.banner?.style.display?.startsWith('block')) {
      const dimension = this.getDimension()
      const newValue = dimension.height > 1
  
      if (this.isFullfilled !== newValue) {
        this.isFullfilled = newValue
        this.$emit('change', dimension)
      }
    }
  }

  updated () {
    this.$nextTick(() => {
      this.init()
    })
  }

  mounted () {
    this.observer = new MutationObserver(() => {
      this.updateStatus()
    })
    this.init()
  }

  unmounted () {
    this.observer?.disconnect()
  }
}
